import { useState, useEffect } from 'react'
import { AxiosInstance } from 'axios'
import useAxios from 'api/useAxios'

export interface FilterItemT {
  id: string | number
  value?: string | number
  label: string
  disabled?: boolean
}

type AlertsFiltersKeysT =
  | 'diseases'
  | 'locations'
  | 'pathogenFamilies'
  | 'pathogenTypes'

export type AlertsFiltersT = Record<AlertsFiltersKeysT, FilterItemT[]>

export type SelectedAlertsFiltersT = Record<
  AlertsFiltersKeysT,
  { label: string; value: string | number }[]
>

export const defaultAlertsFilters = {
  diseases: [],
  locations: [],
  pathogenFamilies: [],
  pathogenTypes: [],
}

export function useAlertsFilters(
  defaultAlerts: AlertsFiltersT = defaultAlertsFilters
) {
  const axios: AxiosInstance = useAxios()
  const [isLoading, setIsLoading] = useState(true)
  const [options, setOptions] = useState<AlertsFiltersT>(defaultAlerts)

  const [selected, setSelected] = useState(defaultAlerts)

  useEffect(() => {
    fetchFilters()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  const updateFilter = (type: keyof SelectedAlertsFiltersT, ids: any[]) => {
    setSelected((prev) => ({ ...prev, [type]: ids }))
  }

  async function fetchFilters() {
    try {
      setIsLoading(true)
      const _selected = {
        selectedDiseases: selected.diseases.map((item) => item.value),
        selectedLocations: selected.locations.map((item) => item.value),
        selectedPathogenFamilies: selected.pathogenFamilies.map(
          (item) => item.value
        ),
        selectedPathogenTypes: selected.pathogenTypes.map((item) => item.value),
      }
      const response = await axios.post('/alerts/filters/', _selected)

      setOptions({
        diseases: response.data.diseases || [],
        locations: response.data.locations || [],
        pathogenFamilies: response.data.pathogenFamilies || [],
        pathogenTypes: response.data.pathogenTypes || [],
      })
    } catch (err) {
      console.error('Error fetching filter data:', err)
    }
  }

  return {
    isLoading,
    options,
    selected,
    updateFilter,
  }
}
